import Action from "../../classes/Action";
import {timelineElementMap} from "../../classes/timeline";
import store, {StoreActions} from "../../state/store";
import {TimelineActionTrackFragment} from "../../classes/timeline/TimelineFragment";
import {ITimelineElement, ITimelineElementParent, TimelineElementTypes} from "../../interfaces/Timeline";
import {Timeline} from "../../classes/timeline/Timeline";
import {ActionDescription, ActionParameters} from "../../classes/api/APIDecorators";
import {RegisterActionWithAPI} from "../../classes/api/Decorators";

@ActionDescription( "Adds an element to the timeline")
@ActionParameters({parent: "ITimelineElementParent | null", element: "ITimelineElement | ITimelineElement[]"})
@RegisterActionWithAPI("AddTimelineElementAction")

export default class AddTimelineElementAction extends Action
{
	constructor(parent: ITimelineElementParent | null, element: ITimelineElement | ITimelineElement[])
	{
		const elementArray = Array.isArray(element) ? element : [element];
		const actionName = `Added ${(elementArray[0].getType !== undefined ? elementArray[0].getType() : "")}${(elementArray.length > 1 ? 's' : `${elementArray[0].name? `: ${elementArray[0].name}` : ""}`)}`;
		
		super(
			[parent, elementArray],
			[parent, elementArray],
			actionName,
			[parent, elementArray]
		);
	}

	do(parent: ITimelineElementParent | null, element: ITimelineElement[]): void
	{
		const timelineId = store.getState().timelineModule.editorData.timelineId;
		if (!timelineId) 
		{
			throw new Error("Timeline ID is undefined");
		}

		const timeline = timelineElementMap.get(timelineId) as Timeline;
		timeline.resetAnimations();

		element.forEach((el) =>
		{
			const parentEl = el.getParent() || parent;

			parentEl.getChildren().push(el);
			el.onAdded();
		});

		timeline.update();
		store.dispatch(StoreActions.timeline.updateEditorUI());

		store.dispatch(StoreActions.timeline.setSelectedElements(element.map((el) => el.id)));
	}

	undo(parent: ITimelineElementParent | null, element: ITimelineElement[]): void
	{
		const timelineId = store.getState().timelineModule.editorData.timelineId;
		if (!timelineId) 
		{
			throw new Error("Timeline ID is undefined");
		}

		const timeline = timelineElementMap.get(timelineId) as Timeline;
		timeline.resetAnimations();

		element.forEach((el) =>
		{
			const parentEl = el.getParent() || parent;

			parentEl.setChildren(parentEl.getChildren().filter((child) => child.id !== el.id));
			el.onDelete();
		});

		timeline.update();
		store.dispatch(StoreActions.timeline.updateEditorUI());

		store.dispatch(StoreActions.timeline.setSelectedElements([]));
	}

	verify(parent: ITimelineElementParent | null, element: TimelineActionTrackFragment[]): boolean
	{
		const validTypes = [TimelineElementTypes.Channel, TimelineElementTypes.Fragment, TimelineElementTypes.Object, TimelineElementTypes.Track, TimelineElementTypes.ActionTrackFragment];

		for (const el of element)
		{
			if (!el.getType || !validTypes.includes(el.getType()))
			{
				return false;
			}

			const parentEl = el.getParent() || parent;

			for (const child of parentEl.getChildren())
			{
				if (child.id === el.id)
				{
					return false;
				}
			}
		}

		return true;
	}
}
